import { render, staticRenderFns } from "./EventAlias.vue?vue&type=template&id=8976a086&"
import script from "./EventAlias.vue?vue&type=script&lang=js&"
export * from "./EventAlias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports